import { produce } from "immer";

import { WorkbenchHistory } from "./history.types";

export function updateWorkbenchHistoryVersionPanelFileExpanded<
  TFileGroupId extends string,
  TFilePath extends string,
>(
  state: WorkbenchHistory.ExpandedState<TFileGroupId, TFilePath>,
  params: {
    fileGroupId: TFileGroupId;
    filePath: TFilePath;
    expanded: boolean;
  },
): WorkbenchHistory.ExpandedState<TFileGroupId, TFilePath> {
  const { expanded, fileGroupId, filePath } = params;
  return produce(state, (draft) => {
    // @ts-expect-error - this is fine
    draft[fileGroupId] ??= {};
    // @ts-expect-error - this is fine
    draft[fileGroupId][filePath] = expanded;
    return draft;
  });
}

export function selectWorkbenchHistoryVersionPanelFileExpanded<
  TTimelineNodeId extends string,
  TFileGroupId extends string,
  TFilePath extends string,
>(
  state: WorkbenchHistory.State<TTimelineNodeId, TFileGroupId, TFilePath>,
  params: {
    fileGroupId: TFileGroupId;
    filePath: TFilePath;
  },
  defaultValue: boolean = false,
): boolean {
  return (
    state.versionPanel.fileExpanded[params.fileGroupId]?.[params.filePath] ??
    defaultValue
  );
}
